var showspinner = require('./lib/spinner').showspinner
var setSpinner = require('./lib/spinner').setSpinner
var spinner = require('./lib/spinner').spinner
module.exports = {
  showspinner: showspinner,
  spinner: spinner,
  setSpinner: setSpinner
}
